import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  DialogTitle,
  IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const styles = theme => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
});

const CloseableDialogTitle = ({ classes, onClose, children, style, ...props }) => {
  return (
    <DialogTitle disableTypography={typeof children !== 'string'} style={{display: 'flex', alignItems: 'center', height: 64, ...style}} {...props}>
      {children}
      {onClose &&
        <>
          <div style={{width: 40}}/>
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon/>
          </IconButton>
        </>
      }
    </DialogTitle>
  )
};

export default withStyles(styles)(CloseableDialogTitle);